import {App} from "vue";
import {getProperty, setProperty} from "dot-prop";

export default {
  install(vueApp: App<Element>) {
    vueApp.config.globalProperties.$get = getProperty;
    vueApp.config.globalProperties.$set = setProperty;
  },
};